import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import 'animate.css';
import { useAuth } from '../guardarToken/authContext';
import Spinner from '../spinner/Spinner';

const apiUrlLogin = process.env.REACT_APP_API_LOGIN;

function Login() {
  const [usuario, setUsuario] = useState('');
  const [pass, setPass] = useState('');
  const { authToken, setTipoUsuario, tipoUsuario, handleAuthenticationSuccess } = useAuth();
  const [hasRedirected, setHasRedirected] = useState(false);
  const [error, setError] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();

  const [showSplash, setShowSplash] = useState(true);
  const [logoMini, setLogoMini] = useState(false);



  const handleLogin = useCallback(async () => {
    setError(false);

    if (!usuario || !pass) return;

    setShowSpinner(true);
    setTimeout(async () => {
      try {
        console.log('apiUrlLogin:', apiUrlLogin);
        const response = await axios.post(apiUrlLogin, { usuario, pass });
        const { token, tipoUsuario, nombreUsuario, nombreuser, apellido, sector, ubicacion, sede, id } = response.data;

        localStorage.setItem('nombreUsuario', nombreUsuario);
        localStorage.setItem('tipoUsuario', tipoUsuario);
        localStorage.setItem('nombre', nombreuser);
        localStorage.setItem('apellido', apellido);
        localStorage.setItem('sector', sector);
        localStorage.setItem('ubicación', ubicacion);
        // Guardamos id_sede bajo clave id_sede; mantenemos 'sede' solo por compatibilidad temporal
        if (sede != null) {
          localStorage.setItem('id_sede', String(sede));
          localStorage.setItem('sede', String(sede));
        }
        localStorage.setItem('id', id);

        handleAuthenticationSuccess({ token, tipoUsuario, nombreUsuario, nombreuser, apellido, sector, ubicacion, sede, id });
        setTipoUsuario(tipoUsuario);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } catch (err) {
        setError(true);
        console.error('Login error:', err);
      } finally {
        setShowSpinner(false);
      }
    }, 2500);
  }, [usuario, pass, setTipoUsuario, handleAuthenticationSuccess]);

  useEffect(() => {
    if (!hasRedirected) {
      if (tipoUsuario === 'admin') {
        navigate('/admin');
        setHasRedirected(true);
      } else if (tipoUsuario === 'user') {
        navigate('/user');
        setHasRedirected(true);
      }
    }
  }, [tipoUsuario, navigate, hasRedirected]);

  useEffect(() => {
    if (authToken) handleLogin();
  }, [authToken, handleLogin]);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
      setLogoMini(true); // activa modo mini del logo
    }, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 bg-cover bg-center text-white transition-all duration-500"
      style={{
        backgroundImage: `url('/login.jpeg')`,
        backgroundColor: '#0f172a',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Logo animado que se queda arriba */}
      <div
        className={`transition-all duration-1000 z-10 
          ${logoMini ? 'fixed top-4 scale-75' : 'absolute top-1/2 -translate-y-1/2 scale-100'} 
          flex flex-col items-center gap-2 px-4`}
      >
        <img
          src="/logo.jpeg"
          alt="logo"
          className="w-52 h-52 sm:w-44 sm:h-44 rounded-full shadow-lg animate__animated animate__zoomIn"
        />
        <h1 className="text-3xl sm:text-4xl font-bold tracking-wide text-white drop-shadow-lg text-center">
          Commanda App
        </h1>
        {showSplash && (
          <p className="text-sm text-slate-300 mt-1 animate__animated animate__fadeInUp animate__delay-2s text-center">
            Cargando módulo de viandas...
          </p>
        )}
      </div>

      {/* Cuerpo del login o spinner */}
      {showSplash ? null : showSpinner ? (
        // Spinner de carga al hacer login
        <div className="mt-36 flex flex-col items-center gap-4 z-10">
          <Spinner />
          <p className="text-lg font-semibold">Verificando credenciales...</p>
        </div>
      ) : (
        // Formulario login
        <div className="animate__animated animate__fadeInUp w-full max-w-md bg-slate-900 bg-opacity-70 backdrop-blur-xl p-8 rounded-2xl shadow-2xl border border-white/10 z-10 mt-0 mx-auto" style={{ marginTop: '-40px' }}>
          {/* Gradiente decorativo arriba */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 via-indigo-500 to-purple-500 rounded-t-2xl"></div>

          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">
              Iniciar Sesión
            </h2>
            <p className="text-slate-400 text-sm mt-2">Accede a tu cuenta</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="p-3 bg-red-500/20 border border-red-500 rounded-lg">
                <p className="text-red-300 text-sm font-semibold text-center">
                  Usuario o contraseña incorrectos
                </p>
              </div>
            )}
            <div className="space-y-1">
              <label className="text-sm text-slate-300 font-medium">Usuario</label>
              <input
                type="text"
                placeholder="Ingresa tu usuario"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                className={`w-full px-4 py-3 rounded-lg bg-slate-800/50 text-white border transition-all ${error ? 'border-red-500 focus:ring-red-500' : 'border-slate-600 focus:ring-indigo-500'
                  } focus:outline-none focus:ring-2 focus:border-transparent placeholder-slate-500`}
              />
            </div>
            <div className="space-y-1">
              <label className="text-sm text-slate-300 font-medium">Contraseña</label>
              <input
                type="password"
                placeholder="Ingresa tu contraseña"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
                className={`w-full px-4 py-3 rounded-lg bg-slate-800/50 text-white border transition-all ${error ? 'border-red-500 focus:ring-red-500' : 'border-slate-600 focus:ring-indigo-500'
                  } focus:outline-none focus:ring-2 focus:border-transparent placeholder-slate-500`}
              />
            </div>
            <button
              type="submit"
              className="w-full py-3 rounded-lg bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 mt-6"
            >
              Entrar
            </button>
          </form>

          {/* Decoración inferior */}
          <div className="mt-6 pt-6 border-t border-slate-700/50">
            <p className="text-slate-400 text-xs text-center">
              Sistema de Pedidos • Comedor Institucional
            </p>
          </div>
        </div>
      )}
    </div>
  );

}


export default Login;